import '@/spa/fonts.css'
import '@/styles/globals.css'

import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { startHardLoadPrefetch } from '@/layouts/customer/parallel-bootstrap-prefetch'
import { router } from '@/spa/router'
import { deferBrowserSentry } from '@/spa/sentry'

// A hard load of a customer-shell page asks for the JWT and the page's first
// reads now, in parallel with the guard's get-session, instead of after it.
// Fire-and-forget: it never rejects, and the layout fetches for itself on any
// failure. Auth pages (_bare) never ask: there is usually no session there.
const bootPathname = window.location.pathname
if (router.getMatchedRoutes(bootPathname)[0].some((route) => route.id === '/_shell')) {
  void startHardLoadPrefetch(bootPathname)
}

// Sentry.init runs after first paint, not before the first render; errors
// thrown before it are queued and reported once it has (see sentry.ts).
deferBrowserSentry(router)

const container = document.getElementById('root')
if (!container) throw new Error('Root container is missing from index.html.')

// reactStrictMode: true in next.config.js.
createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
